import { Inbox } from 'lucide-react';
import { CommunicationInbox } from '../components/CommunicationInbox';
import { ModuleHero } from '../components/ModuleHero';
import { findProfileByEmail } from '../services/directoryService';
import { useAuth } from '../state/AuthContext';
import { useActiveRole } from '../state/RoleContext';

export function PersonalInboxPage() {
  const { googleEmail } = useAuth();
  const { profile: fallbackProfile } = useActiveRole();
  const matchedProfile = googleEmail ? findProfileByEmail(googleEmail) : fallbackProfile;

  return (
    <>
      <ModuleHero
        eyebrow="Your hub"
        title="Inbox"
        description="A consistent message center for league updates, team conversations, and replies that need to stay with your hockey profile."
        icon={Inbox}
        accent="ice"
      />
      <CommunicationInbox mode="personal" profileId={matchedProfile?.id} />
    </>
  );
}
